import React from "react";
import { CheckboxField } from "@codway-dev/ui";
import { EditorField } from "../../../../store";

interface InputPreviewProps {
  field: EditorField;
  dynamicStyle: React.CSSProperties;
  onUpdate: (value: string) => void;
  error?: string;
}

export const CheckboxInputPreview: React.FC<InputPreviewProps> = ({
  field,
  dynamicStyle,
  onUpdate,
  error,
}) => {
  return (
    <div className="mt-2" style={dynamicStyle}>
      <CheckboxField
        id={field.key}
        label={field.label}
        checkboxLabel={field.placeholder}
        checked={field.defaultValue === "true"}
        onChange={(checked) => onUpdate(String(checked))}
        required={field.required}
        error={error}
      />
    </div>
  );
};
